import { useQuery } from 'react-query';
import http from '../../utils/http';
import API_ENDPOINTS from '../../utils/api-endpoints';


export const fetchBriefList = async () => {
    const { data } = await http.get(`${API_ENDPOINTS.GET_BRIEF_LIST}`);

	return data.data || [];
}

export const useFetchBriefList = () => {
    return useQuery(
        [API_ENDPOINTS.GET_BRIEF_LIST],
        fetchBriefList,
        {
			refetchOnMount: true,
		},

    )
}


